import { FC } from 'react';
import { Link } from 'react-router-dom';
import RoutingUtils from '../utils/utils-routing';
import { RefineSearchButtons } from './RefineSearchButtons';
import { SearchScope } from './utils/types';

type Props = {
    readonly searchScope?: SearchScope;
    readonly currentRefine?: string;
    readonly refinedSearchCategories?: { [key: string]: string };
    readonly didYouMean?: string;
    readonly onUnsetRefineSearch: () => void;
    readonly onRefineSearch: (refine: string) => void;
};

const SearchResultHeader: FC<Props> = ({
    currentRefine,
    didYouMean,
    onRefineSearch,
    onUnsetRefineSearch,
    refinedSearchCategories,
    searchScope
}) => {
    return (
        <div className="search-results-header">
            {didYouMean && searchScope?.key ? (
                <div className="did-you-mean">
                    <h4>Did you mean...</h4>
                    <Link
                        className="dym-label"
                        key="did-you-mean"
                        to={RoutingUtils.searchLocationDescriptor(didYouMean, searchScope.key)}
                    >
                        {didYouMean}
                        <i className="material-icons dym-ic">arrow_forward</i>
                    </Link>
                </div>
            ) : null}
            <RefineSearchButtons
                refinedSearchCategories={refinedSearchCategories}
                onRefineSearch={onRefineSearch}
                onUnsetRefineSearch={onUnsetRefineSearch}
                currentRefine={currentRefine}
            />
        </div>
    );
};

export default SearchResultHeader;
